import React from "react";
import { LayoutGrid, List } from "lucide-react";

const DEFAULT_ITEMS = [
  { key: "cards", icon: LayoutGrid, label: "Vignettes" },
  { key: "list", icon: List, label: "Liste" },
];

/** Sélecteur de vue compact — icônes seules + infobulle (libellé accessible conservé). */
export default function ViewToggle({ value, onChange, testid = "view-toggle", items = DEFAULT_ITEMS }) {
  return (
    <div className="inline-flex items-center gap-0.5 p-1 rounded-xl bg-slate-100 shrink-0" role="tablist" data-testid={testid}>
      {items.map(({ key, icon: Icon, label }) => {
        const active = value === key;
        return (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={active}
            aria-label={label}
            title={label}
            onClick={() => onChange(key)}
            className={`inline-flex items-center justify-center h-8 w-8 rounded-lg transition-colors ${
              active ? "bg-white shadow-sm text-slate-900" : "text-slate-500 hover:text-slate-700"
            }`}
            data-testid={`${testid}-${key}`}
          >
            {Icon && <Icon className="h-4 w-4" />}
            <span className="sr-only">{label}</span>
          </button>
        );
      })}
    </div>
  );
}

export function useViewMode(key, initial = "list") {
  const [mode, setMode] = React.useState(() => localStorage.getItem(`jn_view_${key}`) || initial);
  const set = (m) => { setMode(m); localStorage.setItem(`jn_view_${key}`, m); };
  return [mode, set];
}
